export default "/img/MW.d20aaff72c069ed76f167ec0964de52c.png";